export enum PAYMENT_PERIOD_TYPE {
    FULL_MONTH = "FULL_MONTH",   // ทั้งเดือน
    INSTALLMENT = "INSTALLMENT", // เป็นงวด
}

